/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationOutsourcedServicesAliases {
  BUTTON_CLEAN = 'button-clean',
  BUTTON_CONFIRM = 'button-confirm',
  CHECKBOX_ACCREDITED = 'checkbox-accredited',
  DECK_OUTSOURCED_SERVICES = 'deck-outsourced-services',
  DYNAMIC_FIELD_ACCREDITED = 'dynamic-field-accredited',
  FETCH_OUTSOURCED_SERVICE = 'fetch-outsourced-service',
  FETCH_OUTSOURCED_SERVICES = 'fetch-outsourced-services',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FIELD_0 = 'field-0',
  FIELD_ACCREDITED = 'field-accredited',
  FIELD_EMPLOYER_IDENTIFICATION_NUMBER = 'field-employer-identification-number',
  FIELD_NAME = 'field-name',
  FIELD_NAMES_OUTSOURCED_SERVICES = 'field-names-outsourced-services',
  FIELD_NRSEQUENCE = 'field-nrsequence',
  FIELD_PROVIDER_CODE = 'field-provider-code',
  FIELD_SEQUENCE = 'field-sequence',
  FIELD_SERVICE = 'field-service',
  FIELD_SERVICES = 'field-services',
  FORM_0 = 'form-0',
  FORM_OUTSOURCED_SERVICE = 'form-outsourced-service',
  HPMS_CUSTOM_CARD_OUTSOURCED_SERVICES = 'hpms-custom-card-outsourced-services',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_PROVIDER_CODE = 'input-provider-code',
  LAYOUT_0 = 'layout-0',
  LAYOUT_OUTSOURCED_SERVICES = 'layout-outsourced-services',
  MAPPER_0 = 'mapper-0',
  PANEL_CONFIRM = 'panel-confirm',
  PANEL_OUTSOURCED_SERVICE = 'panel-outsourced-service',
  PANEL_OUTSOURCED_SERVICES = 'panel-outsourced-services',
  PANEL_OUTSOURCED_SERVICES_LIST = 'panel-outsourced-services-list',
  PANEL_PENDENCIES = 'panel-pendencies',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_AREA_SERVICE = 'text-area-service',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { ProviderAccreditationOutsourcedServicesAliases };
